import React, { useEffect, useRef, useState } from 'react'

const INTRO = [
  { cmd: 'whoami', out: ['amaan_akbany — AI ML developer & cloud engineer'] },
  { cmd: 'cat focus.txt', out: ['Machine Learning · Computer Vision · RAG · AWS Cloud'] },
  {
    cmd: 'ls certifications/',
    out: [
      'claude_certified_architect.pdf',
      'associate_google_cloud_engineer.pdf',
      'github_foundations.pdf',
    ],
  },
]

const COMMANDS = {
  help: ['Available: whoami, skills, projects, contact, clear'],
  whoami: ['amaan_akbany — AI ML developer & cloud engineer'],
  skills: ['Python · FastAPI · LangChain · OpenCV · AWS · GCP · React'],
  projects: ['Manufex · Konark Vision · Vision Manufex · Audio Spectrum AI'],
  contact: ['linkedin.com/in/amaan-akbany5', 'github.com/Amaan-AeonX'],
}

function InteractiveTerminal() {
  const [lines, setLines] = useState([])
  const [typing, setTyping] = useState('')
  const [ready, setReady] = useState(false)
  const [input, setInput] = useState('')
  const bodyRef = useRef(null)
  const inputRef = useRef(null)

  // Typed intro sequence
  useEffect(() => {
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches
    if (reduce) {
      setLines(INTRO.flatMap(s => [{ type: 'cmd', text: s.cmd }, ...s.out.map(o => ({ type: 'out', text: o }))]))
      setReady(true)
      return
    }
    let cancelled = false
    const sleep = ms => new Promise(r => setTimeout(r, ms))
    ;(async () => {
      await sleep(700)
      for (const step of INTRO) {
        for (let i = 1; i <= step.cmd.length; i++) {
          if (cancelled) return
          setTyping(step.cmd.slice(0, i))
          await sleep(55)
        }
        await sleep(250)
        if (cancelled) return
        setTyping('')
        setLines(l => [...l, { type: 'cmd', text: step.cmd }])
        for (const o of step.out) {
          await sleep(140)
          if (cancelled) return
          setLines(l => [...l, { type: 'out', text: o }])
        }
        await sleep(350)
      }
      if (!cancelled) setReady(true)
    })()
    return () => { cancelled = true }
  }, [])

  useEffect(() => {
    if (bodyRef.current) bodyRef.current.scrollTop = bodyRef.current.scrollHeight
  }, [lines, typing])

  const run = e => {
    e.preventDefault()
    const cmd = input.trim().toLowerCase()
    setInput('')
    if (!cmd) return
    if (cmd === 'clear') return setLines([])
    const out = COMMANDS[cmd] || [`command not found: ${cmd} (try "help")`]
    setLines(l => [...l, { type: 'cmd', text: cmd }, ...out.map(o => ({ type: 'out', text: o }))])
  }

  return (
    <div className="terminal-window" onClick={() => inputRef.current && inputRef.current.focus()}>
      <div className="terminal-header">
        <div className="terminal-dot red"></div>
        <div className="terminal-dot yellow"></div>
        <div className="terminal-dot green"></div>
        <span className="terminal-title">amaan@portfolio — zsh</span>
      </div>
      <div className="terminal-body terminal-scroll" ref={bodyRef}>
        {lines.map((l, i) =>
          l.type === 'cmd' ? (
            <div className="terminal-line" key={i}>
              <span className="terminal-prompt">$</span>
              <span className="terminal-cmd">{l.text}</span>
            </div>
          ) : (
            <div className="terminal-output" key={i}>{l.text}</div>
          )
        )}
        {!ready ? (
          <div className="terminal-line">
            <span className="terminal-prompt">$</span>
            <span className="terminal-cmd">{typing}</span>
            <span className="terminal-cursor"></span>
          </div>
        ) : (
          <form className="terminal-line" onSubmit={run}>
            <span className="terminal-prompt">$</span>
            <input
              ref={inputRef}
              className="terminal-input"
              value={input}
              onChange={e => setInput(e.target.value)}
              placeholder='try "help"'
              aria-label="Terminal command"
              autoComplete="off"
              spellCheck="false"
            />
          </form>
        )}
      </div>
    </div>
  )
}

export default InteractiveTerminal
